module.exports = __webpack_public_path__ + "static/media/solved-tasks.7070a47f.svg";